import { render, staticRenderFns } from "./TraduccionCRUD.vue?vue&type=template&id=3846ae09"
import script from "./TraduccionCRUD.vue?vue&type=script&lang=js"
export * from "./TraduccionCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports